// SPDX-FileCopyrightText: OpenTalk GmbH <mail@opentalk.eu>
//
// SPDX-License-Identifier: EUPL-1.2
import { FormWrapper } from './FormWrapper';

export type { FormProps } from './FormWrapper';

export default FormWrapper;
